module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Navigation/Up-left-c06edabd324be81fa29f3391e5bce97b.svg";